import { Component } from "react";
import { connect } from "react-redux";
import InvoiceTable from "./supply-table";
import InvoiceDetailsModal from "./invoice-details-modal";
import axios from "axios";
import urls from "../../urls";
import SearchInvoice from "./search-invoice";
class Supply extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      showModal: false,
      isLoading: false,
      supplier: "",
      invoiceNumber: "",
      invoiceDate: null,
      table_data: [],
      invoiceId: "",
      showPagination: true,
    };
  }
  handleShowInvoiceDetails = (
    invoice_id,
    supplier,
    invoiceNumber,
    invoiceDate,
    supplier_id
  ) => {
    this.setState({
      showModal: true,
      isLoading: true,
      supplier,
      invoiceNumber,
      invoiceDate,
      invoiceId: invoice_id,
      supplier_id: supplier_id,
    });
    // faculty Id
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));

    axios.get(urls.getInvoiceDetails(invoice_id, faculty_id)).then((res) => {
      console.log("invoice_details", res.data);
      const { invoice_details } = res.data;
      this.setState({
        isLoading: false,
        table_data: invoice_details ? invoice_details : [],
      });
    });
  };
  handleClose = () => {
    this.setState({ showModal: false, isLoading: false });
  };
  render() {
    const {
      showModal,
      isLoading,
      supplier,
      invoiceNumber,
      invoiceDate,
      table_data,
      invoiceId,
      supplier_id,
      showPagination,
    } = this.state;
    return (
      <div>
        <InvoiceDetailsModal
          show={showModal}
          onClose={this.handleClose}
          isLoading={isLoading}
          supplier={supplier}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          table_data={table_data}
          invoiceId={invoiceId}
          supplier_id={supplier_id}
          usePice={this.props.usePice}
        />
        <h5 style={{ display: "flex", alignItems: "center" }}>
          التوريد
          <span
            style={{
              width: 0,
              height: 0,
              borderTop: "6px solid transparent",
              borderBottom: "6px solid transparent",
              borderRight: "10px solid black",
              marginRight: "8px",
            }}
          ></span>{" "}
        </h5>
        <SearchInvoice
          onSearch={() => this.setState({ showPagination: false })}
          onReload={() => this.setState({ showPagination: true })}
        />
        <InvoiceTable
          onInvoiceDetails={this.handleShowInvoiceDetails}
          showPagination={showPagination}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {};
const mapStateToProps = (state) => ({
  usePice: state.settingState.invoice_price,
});
export default connect(mapStateToProps, mapDispatchToProps)(Supply);
